import {useParams, useRouteMatch} from 'react-router-dom';
import {EntityForm} from '../../../../../../../components/entity-form/entity-form';
import {CaregiverMode, ScreenPaths} from '../../../../../../../enums';
import GenericHeader from '../../../../../../../components/generic-header/generic-header';
import {translations} from '../../../../../../../i18n/translations';
import {Box} from '@mui/material';
import {useTranslation} from 'react-i18next';

export default function EntityDetailsSystemAdministratorOfficeScreen() {
  const {t} = useTranslation();
  let {id}: {id?: string} = useParams();
  if (id?.toLowerCase() === 'create') {
    id = undefined;
  }

  // The `path` lets us build <Route> paths that are
  // relative to the parent route, while the `url` lets
  // us build relative links.
  let {url, path} = useRouteMatch();

  return (
    <>
      {!id && (
        <GenericHeader
          titleCrumbs={[
            {
              label: t(translations.entities.root.title),
              link: `${ScreenPaths.Office}${ScreenPaths.Office_SystemAdministrator}/entities`,
            },
            {
              label: t(translations.entity_form.create_entity_title),
              link: path,
            },
          ]}
          isLoading={false}
          leftColumn={null}
          rightColumn={null}
        />
      )}
      <Box className={`listing-container${id ? '-sys' : ''}`}>
        <Box className="listing-container-centered">
          <EntityForm
            caregiverMode={CaregiverMode.SystemAdministrator}
            canWrite
            redirectUrl={id ? `${url.replace(`/${id}`, '')}` : `${url.replace('/create', '')}`}
            showExitButton={id ? false : true}
            showPageTitle={id ? false : true}
            hasDIaccess
          />
        </Box>
      </Box>
    </>
  );
}
